// Google Ads dönüşüm takibi yardımcıları (gtag.js — public/index.html içinde yüklenir)
// Kimlik ve etiket, frontend/.env içindeki ortam değişkenlerinden okunur;
// ileride değiştirmek için sadece bu iki değeri güncellemek yeterlidir:
//   REACT_APP_GOOGLE_ADS_ID                → Dönüşüm Kimliği (Conversion ID, örn. AW-XXXXXXXXX)
//   REACT_APP_GOOGLE_ADS_CONVERSION_LABEL  → Dönüşüm Etiketi (Conversion Label)

export const ADS_TAG_ID = process.env.REACT_APP_GOOGLE_ADS_ID || "";
export const ADS_WHATSAPP_LABEL = process.env.REACT_APP_GOOGLE_ADS_CONVERSION_LABEL || "";

export const trackWhatsAppClick = () => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  // Her durumda 'whatsapp_click' özel olayı gönderilir
  window.gtag("event", "whatsapp_click", { event_category: "iletisim", event_label: "whatsapp_butonu" });
  // Kimlik + etiket tanımlıysa dönüşüm olarak da gönderilir ('Kişi' dönüşümü: 1,00 TRY değer)
  if (ADS_TAG_ID && ADS_WHATSAPP_LABEL) {
    window.gtag("event", "conversion", {
      send_to: `${ADS_TAG_ID}/${ADS_WHATSAPP_LABEL}`,
      value: 1.0,
      currency: "TRY",
    });
  }
};
